import { Action } from '@ngrx/store';
import { RuleCommonParameterModel } from '../../models/RuleCommonParameterModel';

export const GET_COMMON_PARAMETERS_SUCCESS = '[Rule] Get Common Parameters Successfully';

export class GetCommonParametersSuccessAction implements Action {
  readonly type = GET_COMMON_PARAMETERS_SUCCESS;

  constructor(public payload: { model: RuleCommonParameterModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetCommonParametersSuccessAction.ts